import { useAgencySettingsQuery } from 'core/graphql/Settings/AgencySettings.generated';
import { AgencySettings } from 'core/graphql/types';

type AgencySettingsResult = {
  agencySettings: AgencySettings | undefined;
  loadingSettings: boolean;
  refresh: () => Promise<void>;
};

const useAgencySettingsDataStore = (agencyId: string): AgencySettingsResult => {
  const { loading, data, refetch } = useAgencySettingsQuery({
    skip: !agencyId,
    variables: {
      agencyId,
    },
  });

  const refresh = async () => {
    await refetch({
      agencyId,
    });
  };

  if (data !== undefined) {
    return {
      agencySettings: data.AgencySettings,
      loadingSettings: loading,
      refresh,
    };
  }

  return {
    agencySettings: undefined,
    loadingSettings: loading,
    refresh,
  };
};

export default useAgencySettingsDataStore;
